
// Formate numbers from xxxxxxx to x xxx xxx
export const numberWithSpaces = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export const isToday = (someDate) => {
  if(typeof someDate === 'string') {
    someDate = new Date(someDate);
  }
    const today = new Date()
    return someDate.getDate() == today.getDate() &&
      someDate.getMonth() == today.getMonth() &&
      someDate.getFullYear() == today.getFullYear()
  }

  export const isYesterday = (someDate) => {
    
    if(typeof someDate === 'string') {
      try {
        someDate = new Date(someDate);
        
      } catch (error) {
        console.log(error);
      }
    }

    try {
      const compTo = new Date()
      compTo.setDate(compTo.getDate()-1)
      return someDate.getDate() == compTo.getDate() &&
        someDate.getMonth() == compTo.getMonth() &&
        someDate.getFullYear() == compTo.getFullYear()  
    } catch (error) {
    }
    
  }
  
  
 export const appendLeadingZeroes = (n) => {
    if( n <= 9) {
        return "0"+n
    }
    return n;
}

export const thisWeek = (n) => {
  let lastDayOfWeek = new Date();
  lastDayOfWeek.setDate(lastDayOfWeek.getDate()+ (7 - lastDayOfWeek.getDay()));
  if((lastDayOfWeek.getDate() - n.getDate()) < 7 && (lastDayOfWeek.getDate() - n.getDate() >= 0)) {
      return true;
  }        
   return false;
}


export const getParameterByName = (name, url) => {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const getPercentage = (value, max) => {
  return ((value / max) * 100).toFixed(1);
};
